import { render, staticRenderFns } from "./nursingDeploy.vue?vue&type=template&id=2e88b6ff&scoped=true"
import script from "./nursingDeploy.vue?vue&type=script&lang=js"
export * from "./nursingDeploy.vue?vue&type=script&lang=js"
import style0 from "./nursingDeploy.vue?vue&type=style&index=0&id=2e88b6ff&prod&lang=scss&scoped=true"
import style1 from "./nursingDeploy.vue?vue&type=style&index=1&id=2e88b6ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88b6ff",
  null
  
)

export default component.exports